import { render, staticRenderFns } from "./SaleManagementRanking.vue?vue&type=template&id=71acbaca&scoped=true"
import script from "./SaleManagementRanking.vue?vue&type=script&lang=js"
export * from "./SaleManagementRanking.vue?vue&type=script&lang=js"
import style0 from "./SaleManagementRanking.vue?vue&type=style&index=0&id=71acbaca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71acbaca",
  null
  
)

export default component.exports